import styled from 'styled-components'

export const AcceptanceCriteriaStepContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0px 0px;
`
